import {
    ClientExercisesContext,
    initialClientExercisesContext,
} from "@/Contexts/ClientExercisesContext";
import { PageProps } from "@/types/page";
import { onUserEvent } from "@/utils/EventListener";
import Storage from "@/utils/Storage";
import { usePage } from "@inertiajs/react";
import axios from "axios";
import { PropsWithChildren, useEffect, useState } from "react";

export function ClientExercisesProvider({ children }: PropsWithChildren) {
    const { user } = usePage<PageProps>().props;

    const localStorageKey = `hasExercises_${user?.id ?? "unknown"}`;

    const [hasExercises, setHasExercises] = Storage.useReactPersist<boolean>(
        localStorageKey,
        initialClientExercisesContext.hasExercises,
    );

    const [incompleteExercisesCount, setIncompleteExercisesCount] = useState(
        initialClientExercisesContext.incompleteExercisesCount,
    );

    const loadClientExercises = async () => {
        if (user?.type !== "client" || !user?.email_verified_at) {
            return;
        }

        try {
            const { data } = await axios.get<{
                has_exercises: boolean;
                incomplete_count: number;
            }>(route("client-exercises.counts"));

            setHasExercises(data.has_exercises);
            setIncompleteExercisesCount(data.incomplete_count);
        } catch (error) {
            console.error("Failed to load client exercise counts:", error);
        }
    };

    useEffect(() => {
        loadClientExercises();
    }, [user?.type, user?.id, user?.email_verified_at]);

    onUserEvent<{
        hasExercises: boolean;
        incompleteExercisesCount: number;
    }>("ClientExerciseCountsChangedBroadcast", (e) => {
        setHasExercises(e.hasExercises);
        setIncompleteExercisesCount(e.incompleteExercisesCount);
    });

    return (
        <ClientExercisesContext.Provider
            value={{
                hasExercises,
                incompleteExercisesCount,
                loadClientExercises,
            }}
        >
            {children}
        </ClientExercisesContext.Provider>
    );
}
